// --- React
import React from "react";
// --- External UI Libraries
import Paginate from "@dtci/spellbook/Paginate";

/**
 * Pagination component that wraps the Paginate component.
 *
 * @param {Object} props - Component props to be passed to Paginate.
 * @returns {JSX.Element} The rendered Pagination component.
 */
export function Pagination(props) {
  return <Paginate {...props} />;
}
